import { useState, useEffect } from "react";
import { Save } from "lucide-react";
import { adminApi } from "../../api";

export default function PrecarioHeaderForm({ precario, onSaved, onError }) {
  const [form, setForm] = useState({});
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    setForm({
      nome: precario.Nome || "",
      valido_de: precario.ValidoDe || "",
      valido_ate: precario.ValidoAte || "",
      iva_pct: precario.IVA_Pct ?? 23,
      notas: precario.Notas || "",
      activo: precario.Activo || "N",
    });
  }, [precario]);

  const update = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const save = async () => {
    setBusy(true);
    try {
      await adminApi.precarioUpdate(precario.ID_Precario, {
        nome: form.nome,
        valido_de: form.valido_de || null,
        valido_ate: form.valido_ate || null,
        iva_pct: Number(form.iva_pct),
        notas: form.notas || null,
        activo: form.activo,
      });
      onSaved?.();
    } catch (e) { onError?.(e.message); }
    finally { setBusy(false); }
  };

  return (
    <div className="bg-white border border-[#E6E1D6] rounded-md" data-testid="precario-header-form">
      <div className="px-4 py-2.5 border-b border-[#F3F0E7] bg-[#FAF8F2] flex items-center justify-between">
        <span className="text-[11px] uppercase tracking-[0.18em] text-[#978D78] font-bold">
          Cabeçalho · #{precario.ID_Precario} · Ano {precario.Ano}
        </span>
        <button onClick={save} disabled={busy} className="inline-flex items-center gap-1 px-3 py-1 text-xs font-bold uppercase tracking-wider bg-[#0F1829] text-white rounded hover:bg-black disabled:opacity-40" data-testid="precario-header-save">
          <Save size={12} /> {busy ? "A guardar..." : "Guardar"}
        </button>
      </div>
      <div className="p-4 grid grid-cols-1 md:grid-cols-4 gap-3 text-sm">
        <label className="flex flex-col gap-1 md:col-span-2">
          <span className="text-[11px] uppercase tracking-[0.12em] text-[#978D78] font-bold">Nome</span>
          <input value={form.nome || ""} onChange={(e) => update("nome", e.target.value)}
            className="border border-[#E6E1D6] rounded px-2 py-1.5" data-testid="precario-header-nome" />
        </label>
        <label className="flex flex-col gap-1">
          <span className="text-[11px] uppercase tracking-[0.12em] text-[#978D78] font-bold">IVA %</span>
          <input type="number" step="0.01" value={form.iva_pct ?? 23} onChange={(e) => update("iva_pct", e.target.value)}
            className="border border-[#E6E1D6] rounded px-2 py-1.5" data-testid="precario-header-iva" />
        </label>
        <label className="flex flex-col gap-1">
          <span className="text-[11px] uppercase tracking-[0.12em] text-[#978D78] font-bold">Activo</span>
          <select value={form.activo || "N"} onChange={(e) => update("activo", e.target.value)}
            className="border border-[#E6E1D6] rounded px-2 py-1.5" data-testid="precario-header-activo">
            <option value="S">Sim</option>
            <option value="N">Não</option>
          </select>
        </label>
        <label className="flex flex-col gap-1">
          <span className="text-[11px] uppercase tracking-[0.12em] text-[#978D78] font-bold">Válido de</span>
          <input type="date" value={form.valido_de || ""} onChange={(e) => update("valido_de", e.target.value)}
            className="border border-[#E6E1D6] rounded px-2 py-1.5" data-testid="precario-header-de" />
        </label>
        <label className="flex flex-col gap-1">
          <span className="text-[11px] uppercase tracking-[0.12em] text-[#978D78] font-bold">Válido até</span>
          <input type="date" value={form.valido_ate || ""} onChange={(e) => update("valido_ate", e.target.value)}
            className="border border-[#E6E1D6] rounded px-2 py-1.5" data-testid="precario-header-ate" />
        </label>
        <label className="flex flex-col gap-1 md:col-span-2">
          <span className="text-[11px] uppercase tracking-[0.12em] text-[#978D78] font-bold">Notas</span>
          <input value={form.notas || ""} onChange={(e) => update("notas", e.target.value)}
            className="border border-[#E6E1D6] rounded px-2 py-1.5" data-testid="precario-header-notas" />
        </label>
      </div>
    </div>
  );
}
